import './Vision.css'

const Vision = () => {
  return (
    <div>
      <div className='vision' data-aos="fade-up"
        data-aos-duration="1000">
        <div className='vision-heading'>
          <h2 data-aos="fade-up"
            data-aos-duration="1000">OUR VISION</h2>
          <hr />
        </div>
        <div className='vision-content' data-aos="fade-up"
          data-aos-duration="1000">
          <p>
            Avenue One envisions creating developments<br />
            that are not only visually distinctive but also value-driven,<br /> functionally strong, and for generational wealth.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Vision